import React from 'react';

export const InventoryIcon = () => {
  return (
    <svg viewBox="0 0 300 300" className="w-full h-auto">
      <ellipse cx="150" cy="260" rx="140" ry="20" fill="#d1f4f0" opacity="0.5"></ellipse>
      <ellipse cx="150" cy="255" rx="120" ry="15" fill="#b8ede7" opacity="0.6"></ellipse>
      <ellipse cx="150" cy="250" rx="100" ry="10" fill="#9fe6dd" opacity="0.7"></ellipse>
      <rect x="80" y="120" width="140" height="100" rx="6" fill="#7a9ca5"></rect>
      <rect x="85" y="125" width="130" height="90" rx="5" fill="#8fb3bc"></rect>
      <rect x="95" y="140" width="50" height="60" rx="4" fill="#d4a574"></rect>
      <rect x="100" y="145" width="40" height="50" rx="3" fill="#e6b887"></rect>
      <line x1="105" y1="155" x2="135" y2="155" stroke="#c9985e" strokeWidth="2"></line>
      <line x1="105" y1="165" x2="135" y2="165" stroke="#c9985e" strokeWidth="2"></line>
      <line x1="105" y1="175" x2="125" y2="175" stroke="#c9985e" strokeWidth="2"></line>
      <rect x="155" y="140" width="50" height="60" rx="4" fill="#d4a574"></rect>
      <rect x="160" y="145" width="40" height="50" rx="3" fill="#e6b887"></rect>
      <line x1="165" y1="155" x2="195" y2="155" stroke="#c9985e" strokeWidth="2"></line>
      <line x1="165" y1="165" x2="195" y2="165" stroke="#c9985e" strokeWidth="2"></line>
      <line x1="165" y1="175" x2="185" y2="175" stroke="#c9985e" strokeWidth="2"></line>
      <rect x="100" y="135" width="40" height="8" rx="2" fill="#f59e0b"></rect>
      <rect x="160" y="135" width="40" height="8" rx="2" fill="#f59e0b"></rect>
      <rect x="170" y="180" width="60" height="50" rx="4" fill="#7a9ca5"></rect>
      <rect x="175" y="185" width="50" height="40" rx="3" fill="#8fb3bc"></rect>
      <rect x="180" y="195" width="40" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="180" y="202" width="40" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="180" y="209" width="30" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <rect x="180" y="216" width="25" height="3" rx="1.5" fill="#d1e8ed"></rect>
      <circle cx="195" cy="195" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="195" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="195" r="3" fill="#0d9488"></circle>
      <circle cx="195" cy="202" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="202" r="3" fill="#0d9488"></circle>
      <circle cx="215" cy="202" r="3" fill="#0d9488"></circle>
      <circle cx="195" cy="209" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="209" r="3" fill="#0d9488"></circle>
      <circle cx="195" cy="216" r="3" fill="#0d9488"></circle>
      <circle cx="205" cy="216" r="3" fill="#0d9488"></circle>
      <rect x="90" y="100" width="80" height="60" rx="4" fill="#e5e7eb"></rect>
      <rect x="95" y="105" width="70" height="50" rx="3" fill="#f3f4f6"></rect>
      <line x1="100" y1="115" x2="160" y2="115" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="100" y1="125" x2="160" y2="125" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="100" y1="135" x2="145" y2="135" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="100" y1="145" x2="140" y2="145" stroke="#d1d5db" strokeWidth="2"></line>
    </svg>
  );
};
